import React from 'react';

import CardLayout from '@magoosh/layouts/card';

const ACTAdditionalContentCard: React.FC = (props) => {
  return (
    <CardLayout.Card>
      <h4>Additional Practice Tests</h4>

      <div>
        <a href="https://d19y2ugh44almm.cloudfront.net/Magoosh+ACT+Practice+Test.pdf">Paper Practice Test</a>

        <p>Magoosh offers a full-length printable practice test PDF.</p>
        <p>Once you complete the paper practice test, you can use our answer key to manually calculate your overall and section scores.</p>
        <p><em>The paper practice test uses the same questions that you'll find in our online practice. This means you'll likely see repeat questions if you've already practiced with Magoosh.</em></p>
      </div>

      <hr />

      <div>
        <a href="https://www.act.org/content/dam/act/unsecured/documents/Preparing-for-the-ACT.pdf">
          2023-2024 Preparing for the ACT
        </a>

        <p>This free resource from ACT, Inc. includes one full-length official practice test. Like the Magoosh paper practice test, this exam can be printed and manually scored using the answer key in the PDF.</p>
      </div>

      <hr />

      <div>
        <a href="https://www.amazon.com/dp/1394196504">
          2023-2024 Offical ACT Prep Guide
        </a>

        <p>This ~$30 paid resource from ACT, Inc. includes six full-length official practice tests. Official practice tests are the gold standard for test-accuracy, so we highly recommend these exams.</p>
      </div>
    </CardLayout.Card>
  );
};

export default ACTAdditionalContentCard;
